export default __webpack_public_path__ + "static/egp1-34c951296b795f871bd9ead3ab3bb0f1.jpg";